var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-12 left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.configuration")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.settings")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content col-md-12",
          staticStyle: { background: "var(--bg-grey-color)" }
        },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : [
                _c("section", { staticClass: "col-12 no-padding" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("apps.pos.message.possale") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("apps.pos.message.usefeaturequeue")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "box-input" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        position: "relative",
                                        top: "1px",
                                        left: "-5px"
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.settings.menu_online.is_active,
                                        color: "#A3CA76"
                                      },
                                      model: {
                                        value: _vm.settings.queue.is_active,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settings.queue,
                                            "is_active",
                                            $$v
                                          )
                                        },
                                        expression: "settings.queue.is_active"
                                      }
                                    },
                                    [
                                      !_vm.settings.queue.is_active
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.disabled"))
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.enabled"))
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("apps.pos.message.usefeaturetable")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12 mb-0",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-row no-padding no-margin"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-4",
                                      staticStyle: { padding: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input",
                                          staticStyle: { "border-radius": "0" }
                                        },
                                        [
                                          _c(
                                            "vs-checkbox",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                position: "relative",
                                                top: "1px",
                                                left: "-5px"
                                              },
                                              attrs: {
                                                disabled:
                                                  _vm.settings.menu_online
                                                    .is_active,
                                                color: "#A3CA76"
                                              },
                                              model: {
                                                value:
                                                  _vm.settings.table.is_active,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.settings.table,
                                                    "is_active",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "settings.table.is_active"
                                              }
                                            },
                                            [
                                              !_vm.settings.table.is_active
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.disabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.enabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-8",
                                      staticStyle: {
                                        "padding-left": "0",
                                        "padding-right": "0"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input active",
                                          staticStyle: {
                                            "border-radius":
                                              "0px .25rem .25rem 0",
                                            "border-left": "0",
                                            "padding-right": "3px",
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.pos.message.orderrefname"
                                                  )
                                                ) +
                                                ' "' +
                                                _vm._s(
                                                  _vm.getMasterDataText(
                                                    _vm.settings.table.ref_name,
                                                    _vm.$t
                                                  )
                                                ) +
                                                '"\n                      '
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-light",
                                              staticStyle: {
                                                height: "28px",
                                                "font-size": "11px",
                                                "box-shadow": "none"
                                              },
                                              on: {
                                                click:
                                                  _vm.handleOpenTableMasterData
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.managemasterdata",
                                                      {
                                                        number:
                                                          _vm.settings.table
                                                            .lists.length
                                                      }
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("apps.pos.message.usefeaturedining")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12 mb-0",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-row no-padding no-margin"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-4",
                                      staticStyle: { padding: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input",
                                          staticStyle: { "border-radius": "0" }
                                        },
                                        [
                                          _c(
                                            "vs-checkbox",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                position: "relative",
                                                top: "1px",
                                                left: "-5px"
                                              },
                                              attrs: {
                                                disabled:
                                                  _vm.settings.menu_online
                                                    .is_active,
                                                color: "#A3CA76"
                                              },
                                              model: {
                                                value:
                                                  _vm.settings.dining.is_active,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.settings.dining,
                                                    "is_active",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "settings.dining.is_active"
                                              }
                                            },
                                            [
                                              !_vm.settings.dining.is_active
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.disabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.enabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-8",
                                      staticStyle: {
                                        "padding-left": "0",
                                        "padding-right": "0"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input active",
                                          staticStyle: {
                                            "border-radius":
                                              "0px .25rem .25rem 0",
                                            "border-left": "0",
                                            "padding-right": "3px",
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$t("message.defaultby", {
                                                    value: _vm.defaultDining
                                                  })
                                                ) +
                                                "\n                      "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-light",
                                              staticStyle: {
                                                height: "28px",
                                                "font-size": "11px",
                                                "box-shadow": "none"
                                              },
                                              on: {
                                                click:
                                                  _vm.handleOpenDiningMasterData
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.managemasterdata",
                                                      {
                                                        number:
                                                          _vm.settings.dining
                                                            .options.length
                                                      }
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.pos.message.usefeaturecustomer"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "box-input" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        position: "relative",
                                        top: "1px",
                                        left: "-5px"
                                      },
                                      attrs: { color: "#A3CA76" },
                                      model: {
                                        value: _vm.settings.customer.is_active,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settings.customer,
                                            "is_active",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settings.customer.is_active"
                                      }
                                    },
                                    [
                                      !_vm.settings.customer.is_active
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.disabled"))
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.enabled"))
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.pos.message.usefeaturepaymentmethod"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12 mb-0",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-row no-padding no-margin"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-4",
                                      staticStyle: { padding: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input",
                                          staticStyle: { "border-radius": "0" }
                                        },
                                        [
                                          _c(
                                            "vs-checkbox",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                position: "relative",
                                                top: "1px",
                                                left: "-5px"
                                              },
                                              attrs: { color: "#A3CA76" },
                                              on: {
                                                change:
                                                  _vm.handlePaymentMethodChange
                                              },
                                              model: {
                                                value:
                                                  _vm.settings.payment
                                                    .is_active,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.settings.payment,
                                                    "is_active",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "settings.payment.is_active"
                                              }
                                            },
                                            [
                                              !_vm.settings.payment.is_active
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.disabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.enabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-8",
                                      staticStyle: {
                                        "padding-left": "0",
                                        "padding-right": "0"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input active",
                                          staticStyle: {
                                            "border-radius":
                                              "0px .25rem .25rem 0",
                                            "border-left": "0",
                                            "padding-right": "3px",
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "align-items": "center"
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$t("message.defaultby", {
                                                    value:
                                                      _vm.defaultPaymentMethod
                                                  })
                                                ) +
                                                "\n                      "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-light",
                                              staticStyle: {
                                                height: "28px",
                                                "font-size": "11px",
                                                "box-shadow": "none"
                                              },
                                              on: {
                                                click:
                                                  _vm.handleOpenPaymentMasterData
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.managemasterdata",
                                                      {
                                                        number:
                                                          _vm.settings.payment
                                                            .methods.length
                                                      }
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("message.roundingdecimals")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12 mb-0",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-row no-padding no-margin"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-4",
                                      staticStyle: { padding: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input",
                                          staticStyle: { "border-radius": "0" }
                                        },
                                        [
                                          _c(
                                            "vs-checkbox",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                position: "relative",
                                                top: "1px",
                                                left: "-5px"
                                              },
                                              attrs: { color: "#A3CA76" },
                                              model: {
                                                value:
                                                  _vm.settings.format_number
                                                    .is_round,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.settings.format_number,
                                                    "is_round",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "settings.format_number.is_round"
                                              }
                                            },
                                            [
                                              !_vm.settings.format_number
                                                .is_round
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.disabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.enabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-8",
                                      staticStyle: {
                                        "padding-left": "0",
                                        "padding-right": "0"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input active",
                                          staticStyle: {
                                            "border-radius":
                                              "0px .25rem .25rem 0",
                                            "border-left": "0"
                                          }
                                        },
                                        [
                                          !_vm.settings.format_number.is_round
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.formatnumberpreview",
                                                      {
                                                        string: "479.50"
                                                      }
                                                    )
                                                  )
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.formatnumberpreview",
                                                      { string: "479.50 = 480" }
                                                    )
                                                  )
                                                )
                                              ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.disabledsalewhenproductoutofstock"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-row no-padding no-margin"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-4 no-margin",
                                      staticStyle: { padding: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "box-input",
                                          staticStyle: { "border-radius": "0" }
                                        },
                                        [
                                          _c(
                                            "vs-checkbox",
                                            {
                                              staticStyle: {
                                                float: "left",
                                                position: "relative",
                                                top: "1px",
                                                left: "-5px"
                                              },
                                              attrs: { color: "#A3CA76" },
                                              model: {
                                                value:
                                                  _vm.settings
                                                    .product_out_of_stock
                                                    .sale_disabled,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.settings
                                                      .product_out_of_stock,
                                                    "sale_disabled",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "settings.product_out_of_stock.sale_disabled"
                                              }
                                            },
                                            [
                                              !_vm.settings.product_out_of_stock
                                                .sale_disabled
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.disabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.enabled"
                                                        )
                                                      )
                                                    )
                                                  ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-8 no-margin",
                                      staticStyle: {
                                        "padding-left": "0",
                                        "padding-right": "0",
                                        position: "relative"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            top: "7px",
                                            left: "10px",
                                            "font-size": "14px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      <=\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.settings.product_out_of_stock
                                                .count,
                                            expression:
                                              "settings.product_out_of_stock.count"
                                          }
                                        ],
                                        staticClass:
                                          "form-control text-right text-select-all",
                                        staticStyle: {
                                          "border-left": "none",
                                          "border-radius": "0 .25rem .25rem 0",
                                          "padding-left": "32px"
                                        },
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.settings.product_out_of_stock
                                              .count
                                        },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.settings.product_out_of_stock.count = _vm.setToValidNumber(
                                              _vm.settings.product_out_of_stock
                                                .count
                                            )
                                          },
                                          blur: function($event) {
                                            _vm.settings.product_out_of_stock.count = _vm.setToCustomDigitsNumber(
                                              _vm.settings.product_out_of_stock
                                                .count,
                                              { decimal: 0 }
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.settings.product_out_of_stock,
                                              "count",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" })
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "col-12 no-padding" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("apps.pos.message.menuonline") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.pos.message.defaultqrcodeappprovider"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.settings.menu_online
                                          .default_app_provider,
                                      expression:
                                        "settings.menu_online.default_app_provider"
                                    }
                                  ],
                                  staticClass: "custom-select form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.settings.menu_online,
                                        "default_app_provider",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "web" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "apps.pos.message.defaultqrcodeappproviderweb"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "line" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "apps.pos.message.defaultqrcodeappproviderline"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("apps.pos.message.defaultqrcodetype")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.settings.menu_online
                                          .default_qrcode_type,
                                      expression:
                                        "settings.menu_online.default_qrcode_type"
                                    }
                                  ],
                                  staticClass: "custom-select form-control",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.settings.menu_online,
                                        "default_qrcode_type",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "one_time_use" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.pos.message.qrcodetypeonetimeuse"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "reusable" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.pos.message.qrcodetypereusable"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.pos.message.defaultqrcoderequestapproveacess"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "box-input" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        position: "relative",
                                        top: "1px",
                                        left: "-5px"
                                      },
                                      attrs: { color: "#A3CA76" },
                                      model: {
                                        value:
                                          _vm.settings.menu_online
                                            .default_is_client_approve_access_required,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settings.menu_online,
                                            "default_is_client_approve_access_required",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settings.menu_online.default_is_client_approve_access_required"
                                      }
                                    },
                                    [
                                      !_vm.settings.menu_online
                                        .default_is_client_approve_access_required
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.$t("message.no")))
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.yes"))
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.pos.message.defaultqrcoderequestapproveorder"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "box-input" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        position: "relative",
                                        top: "1px",
                                        left: "-5px"
                                      },
                                      attrs: { color: "#A3CA76" },
                                      model: {
                                        value:
                                          _vm.settings.menu_online
                                            .default_is_client_approve_order_required,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settings.menu_online,
                                            "default_is_client_approve_order_required",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settings.menu_online.default_is_client_approve_order_required"
                                      }
                                    },
                                    [
                                      !_vm.settings.menu_online
                                        .default_is_client_approve_order_required
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.$t("message.no")))
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.yes"))
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.pos.message.defaultqrcodeexpiretime"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.settings.menu_online
                                        .default_qrcode_expire_min,
                                    expression:
                                      "settings.menu_online.default_qrcode_expire_min"
                                  }
                                ],
                                staticClass:
                                  "form-control number-only text-select-all",
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.settings.menu_online
                                      .default_qrcode_expire_min
                                },
                                on: {
                                  keypress: _vm.numberOnly,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.settings.menu_online,
                                      "default_qrcode_expire_min",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 no-padding",
                              staticStyle: { height: "24px" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("apps.pos.message.playalertsound")
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-group col-12",
                              staticStyle: { padding: "0" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "box-input" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        position: "relative",
                                        top: "1px",
                                        left: "-5px"
                                      },
                                      attrs: { color: "#A3CA76" },
                                      model: {
                                        value:
                                          _vm.settings.menu_online
                                            .play_alert_sound.is_active,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settings.menu_online
                                              .play_alert_sound,
                                            "is_active",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "settings.menu_online.play_alert_sound.is_active"
                                      }
                                    },
                                    [
                                      !_vm.settings.menu_online.play_alert_sound
                                        .is_active
                                        ? _c("span", [
                                            _vm._v(_vm._s(_vm.$t("message.no")))
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.yes"))
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "col-12 no-padding" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("apps.pos.message.receipttemplate")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.logo")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-3",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                height: "92px",
                                                "border-radius": "0",
                                                display: "flex"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .shop_logo.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt
                                                          .shop_logo,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.shop_logo.is_active"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt.shop_logo
                                                    .is_active
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-9",
                                          staticStyle: {
                                            "padding-left": "0",
                                            "padding-right": "0",
                                            position: "relative"
                                          }
                                        },
                                        [
                                          [
                                            _vm.isShowFilePond
                                              ? _c("file-pond", {
                                                  ref: "pond",
                                                  attrs: {
                                                    server: {
                                                      process: _vm.process,
                                                      revert: _vm.revert,
                                                      restore: _vm.restore,
                                                      load: _vm.load,
                                                      fetch: _vm.fetch
                                                    },
                                                    name: "file",
                                                    className: "my-pond",
                                                    acceptedFileTypes:
                                                      "image/jpeg, image/png",
                                                    imagePreviewHeight: "60",
                                                    imageCropAspectRatio: "1:1",
                                                    labelIdle: "อัพโหลดรูปภาพ",
                                                    labelTapToUndo: "",
                                                    labelTapToCancel:
                                                      "คลิกเพื่อยกเลิก",
                                                    labelFileProcessing:
                                                      "กำลังอัปโหลด",
                                                    labelFileLoading:
                                                      "กำลังโหลด",
                                                    labelFileProcessingComplete:
                                                      "",
                                                    labelButtonRemoveItem:
                                                      "นำออก",
                                                    labelFileProcessingError:
                                                      "เกิดข้อผิดพลาด",
                                                    labelButtonAbortItemProcessing:
                                                      "ยกเลิก"
                                                  }
                                                })
                                              : _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                      height: "92px",
                                                      padding: "15px 0",
                                                      position: "relative",
                                                      display: "flex",
                                                      "justify-content":
                                                        "flex-start",
                                                      border:
                                                        "1px solid #ced4da",
                                                      "border-left": "0",
                                                      "background-color": "#fff"
                                                    }
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c("img", {
                                                        staticClass: "col-12",
                                                        staticStyle: {
                                                          height: "100%",
                                                          width: "auto"
                                                        },
                                                        attrs: {
                                                          src:
                                                            _vm.settings.receipt
                                                              .shop_logo.value
                                                        }
                                                      })
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          width: "28px",
                                                          position: "absolute",
                                                          top: "5px",
                                                          right: "5px",
                                                          "text-align": "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-sm btn-close-image",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeUploadedImage()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-times"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                          ]
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.shopname")) +
                                      " *\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-3",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .shop_name.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt
                                                          .shop_name,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.shop_name.is_active"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt.shop_name
                                                    .is_active
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-9",
                                          staticStyle: {
                                            "padding-left": "0",
                                            "padding-right": "0",
                                            position: "relative"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.settings.receipt.shop_name
                                                    .value,
                                                expression:
                                                  "settings.receipt.shop_name.value"
                                              }
                                            ],
                                            class: [
                                              "form-control",
                                              !_vm.settings.receipt.shop_name.value.trim()
                                                .length && "is-invalid"
                                            ],
                                            style:
                                              "border-radius: 0 .25rem .25rem 0;padding-left: 15px;" +
                                              (_vm.settings.receipt.shop_name.value.trim()
                                                .length &&
                                                "border-left: none;"),
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "placeholder.filltext"
                                              ),
                                              type: "text"
                                            },
                                            domProps: {
                                              value:
                                                _vm.settings.receipt.shop_name
                                                  .value
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.settings.receipt
                                                    .shop_name,
                                                  "value",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.address")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-3",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .shop_address.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt
                                                          .shop_address,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.shop_address.is_active"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt
                                                    .shop_address.is_active
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-9",
                                          staticStyle: {
                                            "padding-left": "0",
                                            "padding-right": "0",
                                            position: "relative"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.settings.receipt
                                                    .shop_address.value,
                                                expression:
                                                  "settings.receipt.shop_address.value"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            staticStyle: {
                                              "border-left": "none",
                                              "border-radius":
                                                "0 .25rem .25rem 0",
                                              "padding-left": "15px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "placeholder.filltext"
                                              ),
                                              type: "text"
                                            },
                                            domProps: {
                                              value:
                                                _vm.settings.receipt
                                                  .shop_address.value
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.settings.receipt
                                                    .shop_address,
                                                  "value",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.taxpayerno")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-3",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .shop_tax_id.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt
                                                          .shop_tax_id,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.shop_tax_id.is_active"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt
                                                    .shop_tax_id.is_active
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-9",
                                          staticStyle: {
                                            "padding-left": "0",
                                            "padding-right": "0",
                                            position: "relative"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.settings.receipt
                                                    .shop_tax_id.value,
                                                expression:
                                                  "settings.receipt.shop_tax_id.value"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            staticStyle: {
                                              "border-left": "none",
                                              "border-radius":
                                                "0 .25rem .25rem 0",
                                              "padding-left": "15px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "placeholder.filltext"
                                              ),
                                              type: "text"
                                            },
                                            domProps: {
                                              value:
                                                _vm.settings.receipt.shop_tax_id
                                                  .value
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.settings.receipt
                                                    .shop_tax_id,
                                                  "value",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.settings.receipt.shop_tax_id.is_active
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-12 no-padding",
                                      staticStyle: { height: "24px" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.pos.message.showtaxtitle"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group col-12 m-0",
                                      staticStyle: { padding: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-row no-padding no-margin"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-12",
                                              staticStyle: { padding: "0" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "box-input",
                                                  staticStyle: {
                                                    "border-radius": "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "vs-checkbox",
                                                    {
                                                      staticStyle: {
                                                        float: "left",
                                                        position: "relative",
                                                        top: "1px",
                                                        left: "-5px"
                                                      },
                                                      attrs: {
                                                        color: "#A3CA76"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.settings.receipt
                                                            .shop_tax_title
                                                            .is_active,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.settings.receipt
                                                              .shop_tax_title,
                                                            "is_active",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "settings.receipt.shop_tax_title.is_active"
                                                      }
                                                    },
                                                    [
                                                      _vm.settings.receipt
                                                        .shop_tax_title
                                                        .is_active
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "apps.pos.message.show"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "apps.pos.message.hide"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.tel")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-3",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .shop_tel.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt
                                                          .shop_tel,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.shop_tel.is_active"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt.shop_tel
                                                    .is_active
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-9",
                                          staticStyle: {
                                            "padding-left": "0",
                                            "padding-right": "0",
                                            position: "relative"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.settings.receipt.shop_tel
                                                    .value,
                                                expression:
                                                  "settings.receipt.shop_tel.value"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            staticStyle: {
                                              "border-left": "none",
                                              "border-radius":
                                                "0 .25rem .25rem 0",
                                              "padding-left": "15px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "placeholder.filltext"
                                              ),
                                              type: "text"
                                            },
                                            domProps: {
                                              value:
                                                _vm.settings.receipt.shop_tel
                                                  .value
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.settings.receipt.shop_tel,
                                                  "value",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("apps.pos.message.orderno")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-12",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .order_no,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt,
                                                        "order_no",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.order_no"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt.order_no
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.customername")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-12",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .customer_name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt,
                                                        "customer_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.customer_name"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt
                                                    .customer_name
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("apps.pos.message.textfooter")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12 m-0",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row no-padding no-margin"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-3",
                                          staticStyle: { padding: "0" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "box-input",
                                              staticStyle: {
                                                "border-radius": "0"
                                              }
                                            },
                                            [
                                              _c(
                                                "vs-checkbox",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    position: "relative",
                                                    top: "1px",
                                                    left: "-5px"
                                                  },
                                                  attrs: { color: "#A3CA76" },
                                                  model: {
                                                    value:
                                                      _vm.settings.receipt
                                                        .text_footer.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.settings.receipt
                                                          .text_footer,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settings.receipt.text_footer.is_active"
                                                  }
                                                },
                                                [
                                                  _vm.settings.receipt
                                                    .text_footer.is_active
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.show"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.hide"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group col-9",
                                          staticStyle: {
                                            "padding-left": "0",
                                            "padding-right": "0",
                                            position: "relative"
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.settings.receipt
                                                    .text_footer.value,
                                                expression:
                                                  "settings.receipt.text_footer.value"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            staticStyle: {
                                              "border-left": "none",
                                              "border-radius":
                                                "0 .25rem .25rem 0",
                                              "padding-left": "15px"
                                            },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "placeholder.filltext"
                                              ),
                                              type: "text"
                                            },
                                            domProps: {
                                              value:
                                                _vm.settings.receipt.text_footer
                                                  .value
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.settings.receipt
                                                    .text_footer,
                                                  "value",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 mb-2" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("apps.pos.message.papersize")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.settings.print.paper_size,
                                          expression:
                                            "settings.print.paper_size"
                                        }
                                      ],
                                      staticClass: "custom-select form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.settings.print,
                                            "paper_size",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "58mm" } },
                                        [_vm._v("58mm")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "80mm" } },
                                        [_vm._v("80mm")]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 mb-2" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("apps.pos.message.fontsize")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.settings.receipt.font_size,
                                          expression:
                                            "settings.receipt.font_size"
                                        }
                                      ],
                                      staticClass: "custom-select form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.settings.receipt,
                                            "font_size",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: 50 } },
                                        [_vm._v("50%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 60 } },
                                        [_vm._v("60%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 70 } },
                                        [_vm._v("70%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 80 } },
                                        [_vm._v("80%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 90 } },
                                        [_vm._v("90%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 100 } },
                                        [_vm._v("100%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 110 } },
                                        [_vm._v("110%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 120 } },
                                        [_vm._v("120%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 130 } },
                                        [_vm._v("130%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 140 } },
                                        [_vm._v("140%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 150 } },
                                        [_vm._v("150%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 160 } },
                                        [_vm._v("160%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 170 } },
                                        [_vm._v("170%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 180 } },
                                        [_vm._v("180%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 190 } },
                                        [_vm._v("190%")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 200 } },
                                        [_vm._v("200%")]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-md-6",
                            staticStyle: { padding: "24px 40px" }
                          },
                          [
                            _c("BasePosReceiptPreview", {
                              attrs: {
                                receiptReviewInfo: _vm.receiptReviewInfo,
                                paperSize: _vm.settings.print.paper_size,
                                fontSize: _vm.settings.receipt.font_size
                              },
                              on: { onPrint: _vm.handlePrint }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "col-12 no-padding" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("apps.pos.message.issuingreceipt")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.pos.message.autosentreceiptemail"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box-input" },
                                    [
                                      _c(
                                        "vs-checkbox",
                                        {
                                          staticStyle: {
                                            float: "left",
                                            position: "relative",
                                            top: "1px",
                                            left: "-5px"
                                          },
                                          attrs: { color: "#A3CA76" },
                                          model: {
                                            value:
                                              _vm.settings.email_receipt.auto,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settings.email_receipt,
                                                "auto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settings.email_receipt.auto"
                                          }
                                        },
                                        [
                                          !_vm.settings.email_receipt.auto
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.disabled")
                                                  )
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.enabled")
                                                  )
                                                )
                                              ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "apps.pos.message.autoshowqrcodereceipt"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box-input" },
                                    [
                                      _c(
                                        "vs-checkbox",
                                        {
                                          staticStyle: {
                                            float: "left",
                                            position: "relative",
                                            top: "1px",
                                            left: "-5px"
                                          },
                                          attrs: { color: "#A3CA76" },
                                          model: {
                                            value:
                                              _vm.settings.qrcode_receipt.auto,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settings.qrcode_receipt,
                                                "auto",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "settings.qrcode_receipt.auto"
                                          }
                                        },
                                        [
                                          !_vm.settings.qrcode_receipt.auto
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.disabled")
                                                  )
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.enabled")
                                                  )
                                                )
                                              ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("apps.pos.message.autoprint")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box-input" },
                                    [
                                      _c(
                                        "vs-checkbox",
                                        {
                                          staticStyle: {
                                            float: "left",
                                            position: "relative",
                                            top: "1px",
                                            left: "-5px"
                                          },
                                          attrs: { color: "#A3CA76" },
                                          model: {
                                            value: _vm.settings.print.auto,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settings.print,
                                                "auto",
                                                $$v
                                              )
                                            },
                                            expression: "settings.print.auto"
                                          }
                                        },
                                        [
                                          !_vm.settings.print.auto
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.disabled")
                                                  )
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.enabled")
                                                  )
                                                )
                                              ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12 no-padding",
                                  staticStyle: { height: "24px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("apps.pos.message.printcopies")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group col-12",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.settings.print.copies,
                                          expression: "settings.print.copies"
                                        }
                                      ],
                                      staticClass: "custom-select form-control",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.settings.print,
                                            "copies",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    _vm._l(5, function(i) {
                                      return _c(
                                        "option",
                                        { key: i, domProps: { value: i } },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(i) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "col-12 action-bar" }, [
                  !_vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-web",
                            attrs: { disabled: _vm.disabled.btn_save },
                            on: { click: _vm.update }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _vm._m(0)
                      ])
                    : _vm._e()
                ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.ready
        ? _c("receipt-view", {
            staticClass: "receipt-template",
            staticStyle: {
              position: "fixed",
              "z-index": "-1",
              top: "1mm",
              left: "1mm",
              "font-family": "tahoma",
              color: "black",
              width: "100%"
            },
            attrs: {
              shop_logo: _vm.receiptReviewInfo.shopLogo,
              shop_name: _vm.receiptReviewInfo.shopName,
              shop_address: _vm.receiptReviewInfo.shopAddress,
              shop_tax_id: _vm.receiptReviewInfo.shopTaxId,
              shop_tax_title: _vm.receiptReviewInfo.shopTaxTitle,
              shop_tel: _vm.receiptReviewInfo.shopTel,
              orders: _vm.receiptReviewInfo.orders,
              total_price: _vm.receiptReviewInfo.totalPrice,
              receipt_info: _vm.receiptReviewInfo.receiptInfo,
              date_time: _vm.receiptReviewInfo.dateTime,
              text_footer: _vm.receiptReviewInfo.textFooter,
              font_size: _vm.settings.receipt.font_size
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("BaseModalCustomMasterData", {
            attrs: {
              list: _vm.settings.payment.methods,
              id: _vm.MODAL_PAYMENT_MASTER_DATA,
              headerText: _vm.$t("apps.pos.message.managepaymentmethods")
            },
            on: {
              onClose: _vm.handleClosePaymentMasterData,
              onSubmit: _vm.handleSubmitPaymentMasterData
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("BaseModalCustomMasterData", {
            attrs: {
              list: _vm.settings.dining.options,
              id: _vm.MODAL_DINING_MASTER_DATA,
              headerText: _vm.$t("apps.pos.message.managediningoptions")
            },
            on: {
              onClose: _vm.handleCloseDiningMasterData,
              onSubmit: _vm.handleSubmitDiningMasterData
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("BaseModalCustomMasterData", {
            attrs: {
              list: _vm.settings.table.lists.map(function(item) {
                return Object.assign({}, item, { deletable: true })
              }),
              topBodyProps: {
                ref_name: _vm.getMasterDataText(
                  _vm.settings.table.ref_name,
                  _vm.$t
                )
              },
              id: _vm.MODAL_TABLE_MASTER_DATA,
              headerText: _vm.$t("apps.pos.message.managetablelists"),
              showCheckboxDefault: false,
              "master-data-title": _vm.$t("apps.pos.message.masterdatalist")
            },
            on: {
              onClose: _vm.handleCloseTableMasterData,
              onSubmit: _vm.handleSubmitTableMasterData
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body-top",
                  fn: function(ref) {
                    var topBodyProps = ref.topBodyProps
                    return [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("apps.pos.message.orderrefname")
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: topBodyProps.ref_name,
                                  expression: "topBodyProps.ref_name"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: topBodyProps.ref_name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    topBodyProps,
                                    "ref_name",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "small",
                              {
                                staticClass: "form-text text-muted",
                                attrs: { id: "emailHelp" }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.pos.message.orderrefhelpertext"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  }
                }
              ],
              null,
              false,
              2065665343
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a882462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a882462","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/configuration/Setting.vue
// module id = null
// module chunks = 